import { useRootNavigationState } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Safely checks whether the expo-router navigation container is ready.
 *
 * Returns `false` when called outside an expo-router context
 * or before the navigation container has fully mounted.
 */
export const useSafeIsNavigationReady = () => {
  try {
    const rootNavigationState = useRootNavigationState();

    return Boolean(rootNavigationState?.key);
  } catch {
    return false;
  }
};
